// extracted by mini-css-extract-plugin
export default {"loginButton":"GRWkqBToK8LZhqFwZ22G"};